// extracted by mini-css-extract-plugin
export default {"agreeBox":"AgreeBox_agreeBox__ne2Dn"};